import React from 'react';
import {
  Tabs
} from 'antd';
import { useTranslation } from 'react-i18next';
import StorageDocuments from './shared-components/StorageDocuments';
import DbDocuments from './shared-components/DbDocuments';

function Documents() {
  const { t } = useTranslation();
  return (
    <div>
      <Tabs defaultActiveKey="0">
        <Tabs.TabPane tab={t('documents')} key="0">
          <DbDocuments />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('files')} key="1">
          <StorageDocuments />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default Documents;
